import { Alarm } from "./Alarm";
import { SystemMode } from "./SystemMode";


export interface AlarmSettings {
  locationId?: string;
  deviceId?: string;
  alarm: Alarm;
  systemMode: SystemMode;
  smsEnabled?: boolean;
  callEnabled?: boolean;
  emailEnabled?: boolean;
  pushEnabled?: boolean;
}

export enum DeliveryMediumEnabled {
  FALSE, TRUE, MIXED
}

export interface AlarmSettingStatus {
  alarm: Alarm;
  sms: DeliveryMediumEnabled;
  call: DeliveryMediumEnabled;
  email: DeliveryMediumEnabled;
  push: DeliveryMediumEnabled;
  isNested: boolean;
}